import RequestManager from "./RequestManager";

const resetPassword = async (body) => {
    const response = await RequestManager.put({
        url: "/me/resetPassword/v1/",
        handleUnauthorizedResponse: false,
        body
    });
    return response;
};

const completeTraining = async (trainingId) => {
    const response = await RequestManager.put({
        url: "/me/completeTraining/v1",
        body: { trainingId }
    });
    return response;
};

const Me = {
    resetPassword,
    completeTraining
};

export default Me;
